"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseDocumentStore__factory = void 0;
var _ethers = require("ethers");
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

class BaseDocumentStore__factory extends _ethers.ContractFactory {
  constructor(signer) {
    super(_abi, _bytecode, signer);
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address) {
    return super.attach(address);
  }
  connect(signer) {
    return super.connect(signer);
  }
  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }
}
exports.BaseDocumentStore__factory = BaseDocumentStore__factory;
const _abi = [{
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "DocumentIssued",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "DocumentRevoked",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint8",
    name: "version",
    type: "uint8"
  }],
  name: "Initialized",
  type: "event"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "documentIssued",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  name: "documentRevoked",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "getIssuedBlock",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "isIssued",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "blockNumber",
    type: "uint256"
  }],
  name: "isIssuedBefore",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }],
  name: "isRevoked",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "document",
    type: "bytes32"
  }, {
    internalType: "uint256",
    name: "blockNumber",
    type: "uint256"
  }],
  name: "isRevokedBefore",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "version",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}];
const _bytecode = "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";